import { Button } from '@insify/design-system/components';
import { useTranslation } from 'react-i18next';

import { useGetCoiLink } from '../../api/queries/useGetCoiLink';
import { GTMEvent, useTagManager } from '../../hooks/useTagManager';

import * as styles from './CertificateButton.module.css';

import type { Coverage } from '../../types/Policy';

export const CertificateButton: React.FC<{
  coverage: Coverage;
  customerUuid?: string;
}> = ({ coverage, customerUuid }) => {
  const { t } = useTranslation('policy');
  const { sendEvent } = useTagManager();
  const { mutateAsync: getCoiLink, isPending } = useGetCoiLink();

  const handleClick = async () => {
    const pdf = await getCoiLink({ coverage: coverage.title, policyUuid: coverage.policyId, customerUuid });
    sendEvent(GTMEvent.COI, { s3COILink: 'true' });
    window.open(pdf, '_blank') || window.location.assign(pdf);
  };

  if (!coverage.title || coverage.status === 'cancelled') return null;

  return (
    <div className={styles.button}>
      <Button
        trackingId='seeCertificateOfInsurance'
        type='button'
        kind='primary'
        className={styles.certificateButton}
        onClick={handleClick}
        data-testid='certificate-of-insurance'
        loading={isPending}
      >
        {t('policy:download_certificate_of_insurance')}
      </Button>
    </div>
  );
};
